import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=2f2b8b48&scoped=true"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=2f2b8b48&prod&scoped=true&lang=css"
import style1 from "./Datatable.vue?vue&type=style&index=1&id=2f2b8b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b8b48",
  null
  
)

export default component.exports